<template>
  <div>
    <div v-show="Mode==='Merchant'">
      <populate-form
        formTitle="商家與分店帳號管理"
        fkey="mm01"
        ref="filterMerchantForm"
        populateOptionVar="filterMerchantOptions"
        formDataObjVar="filterMerchantFormObj"
        :validatePrompt="false"
        :parentVue="this"
      ></populate-form>
      <back-to-top :text="scrollHint"></back-to-top>
      <b-table stacked="sm" class="" striped hover :items="Merchants" :fields="merchantFields">
        <template slot="actions" slot-scope="row">
          <b-button size="sm" @click.stop="goMerchant(row)" class="mr-1">
            分店管理
          </b-button>
          <b-button size="sm" @click.stop="editMerchant(row)" class="mr-1">
            編輯
          </b-button>
        </template>
      </b-table>
    </div>
    <div v-show="Mode==='MerchantStore'">
      <populate-form
        :formTitle="FocusedMerchant.merchant_name+'_分店帳號管理'"
        fkey="mm02"
        ref="filterStoreForm"
        populateOptionVar="filterStoreOptions"
        formDataObjVar="filterStoreFormObj"
        :validatePrompt="false"
        :parentVue="this"
      ></populate-form>
      <b-table stacked="sm" class="" striped hover :items="FilteredStores" :fields="storeFields">
        <template slot="actions" slot-scope="row">
          <div v-if="row.item.src_type===0">
            <b-button disabled v-if="row.item.is_super_manage==1" class="mr-1">總店</b-button>
            <!--新流程固定會建無密碼店長所以之後是用不到的-->
            <b-button size="sm" v-if="row.item.account==='' && $bus.getRole() === 'admin' " @click.stop="createAdminAccount(row)" class="mr-1">
              建立店長帳號
            </b-button>
            <b-button size="sm" @click.stop="goAccount(row)" class="mr-1">
              帳號管理
            </b-button>
            <!--adm_tel沒有設定時才讓後台修改店長密碼可以使用-->
            <b-button size="sm" v-if="row.item.account!==''&&row.item.new_adm_account&&row.item.adm_tel!==''" @click.stop="sendNewAdmin(row.item)" class="mr-1">
              發送密碼設定簡訊{{row.item.sent_not_expired?'(已寄出未過期)':''}}
            </b-button>
            <b-button size="sm" v-if="row.item.account!==''&&(row.item.adm_tel===''||$bus.getRole()==='merchant')" @click.stop="editAdminPwd(row)" class="mr-1">
              修改店長密碼
            </b-button>
            <b-button size="sm" @click.stop="editStore(row, row.index, $event.target)" class="mr-1">
              編輯
            </b-button>
          </div>
          <div v-if="row.item.src_type === 1">
            <b-button disabled>來自:{{row.item.supplier}}</b-button>
          </div>
        </template>
      </b-table>
    </div>
    <div v-show="Mode==='MerchantAccount'">
      <populate-form
        :formTitle="FocusedMerchant.merchant_name+'_'+FocusedStore.store_name+'_分店帳號管理'"
        fkey="mm03"
        ref="filterAccountForm"
        populateOptionVar="filterAccountOptions"
        formDataObjVar="filterAccountFormObj"
        :validatePrompt="false"
        :parentVue="this"
      ></populate-form>
      <b-table stacked="sm" class="" striped hover :items="FilteredAccounts" :fields="accountFields">
        <template slot="actions" slot-scope="row">
          <b-button v-if="!row.item.last_login_time&&row.item.role_type!=='店長管理者'" size="sm" @click.stop="delSubAccount(row, row.index, $event.target)">
            刪除
          </b-button>
          <b-button v-if="row.item.last_login_time" :disabled="row.item.role_type==='店長管理者'" size="sm" @click.stop="changeSubAccountStatus(row, row.index, $event.target)">
            {{row.item.status==='active'?'停用':'再啟用'}}
          </b-button>
          <b-button size="sm" @click.stop="editSubAccount(row, row.index, $event.target)" class="ml-1">
            編輯
          </b-button>
          <b-button size="sm" :disabled="$bus.getRole()==='admin'" @click.stop="editSubAccountPwd(row, row.index, $event.target)" class="ml-1">
            重設密碼
          </b-button>
        </template>
      </b-table>
    </div>
    <b-modal 
      v-model="showModal" 
      :size="modalSize"
      centered
      hide-header
      hide-footer>
      <component 
        :is="popupItem"
        :parentVue="this"
        :cbSave="undefined"
        :cbCancel="closePopup"
        :reloadList="refreshAccounts"
      />
    </b-modal>
  </div>
</template>

<script>

import MerchantInfo from './MerchantInfo'
import StoreInfo from './StoreInfo'
import AccountQuick from './AccountQuick'
import AccountInfo from './AccountInfo'

export default {
  name: 'MerchantManage',
  components: {
    /* eslint-disable vue/no-unused-components */
    MerchantInfo,
    StoreInfo,
    AccountQuick,
    AccountInfo,
  },
  data: function () {
    return {
      Mode:"Merchant",
      popupItem:"",
      showModal: false,
      modalSize: 'md',
      CachedMerchant:Object,
      merchantFields: [
        {
          key: 'actions',
          label: '操作'
        },
        {
          key: 'supplier_id',
          label: '廠商代號',
          sortable: false
        },
        {
          key: 'merchant_name',
          label: '總管理名稱',
          sortable: false
        },
        {
          key: 'contact_tel',
          label: '電話',
          sortable: false
        },
        {
          key: 'supplier_address',
          label: '地址',
          sortable: false
        },
        {
          key: 'contact_name',
          label: '管理者',
          sortable: false
        },
        {
          key: 'super_admin_account',
          label: '帳號',
          sortable: false
        },
        {
          key: 'contact_email',
          label: '電子郵件',
          sortable: false
        },
      ],
      storeFields: [
        {
          key: 'actions',
          label: '操作'
        },
        {
          key: 'store_id',
          label: '分店代號',
          sortable: true
        },
        {
          key: 'store_name',
          label: '分店名稱',
          sortable: true
        },
        {
          key: 'store_contact_info',
          label: '電話',
          sortable: false
        },
        {
          key: 'store_address',
          label: '地址',
          sortable: true
        },
        {
          key: 'account_name',
          label: '店長',
          sortable: false
        },
        {
          key: 'account',
          label: '帳號',
          sortable: true
        }
      ],
      accountFields: [
        {
          key: 'actions',
          label: '操作'
        },
        {
          key: 'merchant_account_id',
          label: '編號',
          sortable: false
        },
        {
          key: 'account_name',
          label: '姓名',
          sortable: false
        },
        {
          key: 'role_type',
          label: '職稱',
          sortable: false
        },
        {
          key: 'account',
          label: '帳號名稱',
          sortable: false
        },
      ],
      Merchants: [],
      FocusedMerchant: Object,
      FocusedMerchantId:0,
      filterMerchantFormObj: {},
      filterMerchantOptions:[
        {
          'componentType':'text',
          'defaultValue':'',
          'akey':'FilterMerchantName',
          'col':4,
          'label':'',
          'placeholder':'供應商名稱篩選',
          'title':'輸入供應商名稱關鍵字(空白則全部)',
          'isRequired':false,
          'execCallback':this.loadMerchantsEnter
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':6,
          'placeholder':'',
          'title':'',
        },
        {
          'componentType':'b-button',
          'akey':'search',
          'col':2,
          'placeholder':'查詢',
          'execCallback':this.loadMerchants
        }
      ],
      Stores:[],
      FilteredStores:[],
      FocusedStore: Object,
      filterStoreFormObj: {},
      filterStoreOptions:[
        {
          'componentType':'b-button',
          'akey':'back',
          'col':2,
          'placeholder':'回到商家列表',
          'hide':(this.$bus.getRole() !== 'admin'),
          'execCallback':this.backToMerchantList      
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':6,
        },
        {
          'componentType':'text',
          'defaultValue':'',
          'akey':'FilterStore',
          'col':3,
          'label':'',
          'placeholder':'查詢條件',
          'title':'以分店名稱篩選',
          'execCallback':this.filterStore
        },
        {
          'componentType':'b-button',
          'akey':'search2',
          'col':1,
          'placeholder':'篩選',
          'execCallback':this.filterStore
        },
      ],
      Accounts:[],
      FilteredAccounts:[],
      accountAdminDirty:false,
      filterAccountFormObj: {},
      popupAccountFormObj: {},
      filterAccountOptions:[
        {
          'componentType':'b-button',
          'akey':'back',
          'col':2,
          'placeholder':'回到分店列表',
          'hide':(this.$bus.getRole() !== 'admin'&&(this.$bus.session&&!this.$bus.session.is_super_manage)),
          'execCallback':this.backToStoreList      
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':8,
        },
        {
          'componentType':'b-button',
          'defaultValue':'',
          'akey':'bAddAccount',
          'col':2,
          'label':'',
          'placeholder':'新增帳號',
          'title':'',
          'isRequired':false,
          disabled: this.$bus.getRole()==='admin',
          'execCallback':this.createSubAccount
        },
      ]
    }
  },
  methods: {
    sendNewAdmin(store) {
      // 發信給adm_tel,產生一個code請對方設定初始密碼
      let Param = {
        'module':'request_reset',
        'method':store.store_id,
        'useGet':true,
        'apiTarget':'rest'
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.fnShowInfo("已寄出簡訊連結由店家自行設定店長管理帳號的密碼")
      }, this)
    },
    closePopup () {
      this.showModal = false
      this.popupItem = ""
    },
    editMerchant (row) {
      this.FocusedMerchant = this.CpObj(row.item)
      this.popupItem = "MerchantInfo"
      this.modalSize = "lg"
      this.showModal = true
    },
    editStore (row) {
      this.FocusedStore = this.CpObj(row.item)
      this.popupItem = "StoreInfo"
      this.modalSize = "lg"
      this.showModal = true
    },
    createAdminAccount (row) {
      this.popupAccountFormObj = this.CpObj(row.item)
      this.popupAccountFormObj.action = 'create'
      this.popupAccountFormObj.account_name = this.popupAccountFormObj.store_name+"店長帳號"
      this.popupAccountFormObj.row_index = row.index
      this.popupItem = "AccountQuick"
      this.modalSize = "md"
      this.showModal = true
    },
    editAdminPwd (row) {
      this.popupAccountFormObj = this.CpObj(row.item)
      this.popupAccountFormObj.action = 'updpwd'
      //不要殘留上次的密碼,每次都要重填
      this.popupAccountFormObj.password = ''
      this.popupAccountFormObj.password2 = ''
      this.popupItem = "AccountQuick"
      this.modalSize = "md"
      this.showModal = true
    },
    createSubAccount () {
      this.popupAccountFormObj = {
        action: 'create',
        merchant_store_id: this.FocusedMerchantStoreId,
        account: '',
        account_name: '',
        role: 'operator',
        password: '',
        password2: ''
      },
      this.popupItem = "AccountInfo"
      this.modalSize = "md"
      this.showModal = true
    },
    editSubAccount (row) {
      const role = (row.item.role_type === '店長管理者'?'admin':(row.item.role_type === '預約管理者'?'manager':'operator'))
      this.popupAccountFormObj = {
        action: 'update',
        account: row.item.account,
        account_name: row.item.account_name,
        merchant_account_id: row.item.merchant_account_id,
        role: role,
        password: '',
        password2: ''
      },
      this.popupItem = "AccountInfo"
      this.modalSize = "md"
      this.showModal = true
    },
    editSubAccountPwd (row) {
      this.popupAccountFormObj = {
        action: 'updsubpwd',
        merchant_account_id: row.item.merchant_account_id,
        account: row.item.account,
        account_name: row.item.account_name,
        password: '',
        password2: ''
      },
      this.popupItem = "AccountQuick"
      this.modalSize = "md"
      this.showModal = true
    },
    delSubAccount(row) {
      let Param = {
        'module':'merchant',
        'method':'deleteMerchantAccount',
        'merchant_account_id':row.item.merchant_account_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.$bus.fnShowInfo("帳號刪除完成")
          // 立flag店長有變,回上層時要重撈
          if (row.item.role_type === '店長管理者') {
            vm.accountAdminDirty = true
          }
          //省麻煩reload全部子帳號啦
          vm.loadStoreAccounts(row.item.merchant_store_id)
      },this)
    },
    changeSubAccountStatus(row) {
      let Param = {
        'module':'merchant',
        'method':'changeAccountStopStatus',
        'merchant_account_id':row.item.merchant_account_id,
        'change_status':row.item.status==='active'?'stop':'reopen',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          //省麻煩reload全部子帳號啦
          vm.$bus.fnShowInfo("帳號更新完成")
          vm.loadStoreAccounts(row.item.merchant_store_id)
      },this)
    },
    loadMerchantsEnter() {
      if (this.filterMerchantFormObj.FilterMerchantName) {
        this.loadMerchants()
      }
    },
    loadMerchants () {
      let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':this.filterMerchantFormObj.FilterMerchantName.trim(),
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.Merchants = data.data
      },this)
    },
    goMerchant(row) {
      setTimeout(() => {
        this.FocusedMerchantId = row.item.merchant_id
        this.loadMerchantById(row.item.merchant_id)
        this.Mode = "MerchantStore"
      }, 300);
    },
    loadMerchantById(merchant_id) {
      // 回到預設
      this.Stores = []
      this.SelectedStoreId = null
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+this.FocusedMerchantId)) {
        this.FocusedMerchant = this.CachedMerchant['m_'+this.FocusedMerchantId]
        this.Stores = this.FocusedMerchant.merchant_stores
        this.FilteredStores = this.Stores
      }
      else {
        this.FocusedMerchantId = merchant_id
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':merchant_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.FocusedMerchant = vm.CpObj(data.data)
            vm.Stores = data.data.merchant_stores
            vm.FilteredStores = vm.Stores
            vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        },this)
      }
    },
    backToMerchantList() {
      this.FocusedMerchantId = 0
      this.filterStoreFormObj.FilterStore = ""
      this.$refs.filterStoreForm.refreshModelVar('FilterStore')
      setTimeout(() => {
        this.Mode = "Merchant"
      }, 300);
    },
    filterStore () {
      if (this.filterStoreFormObj.FilterStore === "") {
        this.FilteredStores = this.Stores
      }
      else {
        this.FilteredStores = []
        for (let i=0;i<this.Stores.length;i++) {
          if (this.Stores[i].store_name.includes(this.filterStoreFormObj.FilterStore)) {
            this.FilteredStores.push(this.Stores[i])
          }
        }
      }
    },
    refreshAccounts() {
      this.loadStoreAccounts(this.FocusedMerchantStoreId)
    },
    loadStoreAccounts (store_id) {
      // 回到預設
      this.Accounts = []
      this.FocusedMerchantStoreId = store_id
      // 再抓資料庫放cache
      let Param = {
        'module':'merchant',
        'method':'get_account_list',
        'store_id':this.FocusedMerchantStoreId,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.Accounts = data.data.result_accounts
          vm.FilteredAccounts = vm.Accounts
      },this)
    },
    goAccount(row) {
      setTimeout(() => {
        this.FocusedStore = row.item
        this.accountAdminDirty = false
        this.loadStoreAccounts(row.item.id)
        this.Mode = "MerchantAccount"
      }, 300);
    },
    backToStoreList() {
      if (this.accountAdminDirty) {
        delete this.CachedMerchant['m_'+this.FocusedMerchantId]
        this.loadMerchantById(this.FocusedMerchantId)
        this.accountAdminDirty = false
      }      
      setTimeout(() => {
        this.Mode = "MerchantStore"
      }, 300);
    },
  },
  computed:{
    scrollHint: {
      cache:false,
      get() {
        switch (this.Mode) {
          case 'Merchant':
            return '回到頂端(總數'+this.Merchants.length+')'
          case 'MerchantStore':
            return '回到頂端(總數'+this.Stores.length+')'
          case 'MerchantAccount':
            return '回到頂端(總數'+this.Accounts.length+')'
        }
      }
    }
  },
  created () {
    if (!this.$bus.session) {
      this.$bus.session = undefined
    }
    // 根據角色決定初始role
    if (this.$bus.getRole() === 'admin') {
      this.Mode = "Merchant"
    }
    else if (this.$bus.getRole() === 'merchant' && this.$bus.session && this.$bus.session.is_super_manage) {
      this.Mode = "MerchantStore"
      this.FocusedMerchant = {
        'merchant_id':this.$bus.session.merchant_id,
        'merchant_name':this.$bus.session.merchant_name,
      }
      this.FocusedMerchantId = this.$bus.session.merchant_id
      this.loadMerchantById(this.FocusedMerchantId)
    }
    else {
      if (!this.$bus.session) {
        // 導到登入
        this.$bus.session
        return
      }
      this.Mode = "MerchantAccount"
      this.FocusedMerchant = {
        'merchant_id':this.$bus.session.merchant_id,
        'merchant_name':this.$bus.session.merchant_name,
      }
      this.FocusedMerchantStoreId = this.$bus.session.merchant_store_id
      this.FocusedStore = {
        'id':this.$bus.session.merchant_store_id,
        'store_name':this.$bus.session.store_name,
      }
      this.loadStoreAccounts(this.$bus.session.merchant_store_id)
    }
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterMerchantForm.initDefault()
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
